import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IRemoteFinish } from 'app/interfaces/IRemoteFinish';
import { IRemotePower } from 'app/interfaces/IRemotePower';
import { IRemotePowerDetails } from 'app/interfaces/IRemotePowerDetails';
import { IUserDefArea } from 'app/interfaces/IUserDefArea';
import { Observable } from 'rxjs';
import { GlobalsService } from './globals.service';
import { HeaderService } from './header.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class RemotePowerService {
  
  constructor(
    private http: HttpClient,
    private globalService: GlobalsService,
    private headerService: HeaderService
    ) {
  }
    
    getRemotePowerDetialsTechOptions(): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/technologiesCodelist';
      return this.http.get<any>(url, {
        headers: this.headerService.getHttpHeaders()
      }).pipe(
        catchError((error) => throwError(() => error))
      );
    }
    
    getRemotePowerSizeTypes(): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/sistemSizeCodelist';
      return this.http.get<any>(url, {
        headers: this.headerService.getHttpHeaders()
      }).pipe(
        catchError((error) => throwError(() => error))
      );
    }

    getUserDefinedHeatingAreaStatus(userId: string, mid: number): Observable<any> {
      const url =
        this.globalService.getRestUrl()
        + `/api/planiranjeDaljinskoOgrevanje/userDefinedHeatingArea/status`
        + `?userId=${userId}&mid=${mid}`;

      return this.http.get<any>(url, {
        headers: this.headerService.getHttpHeaders()
      });
    }

    cancelUserDefinedAreaCalc(heatingSystemId: number): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/userDefinedHeatingArea/cancelCalculation';

      const params = new HttpParams().set('heatingSystemId', String(heatingSystemId));

      return this.http.get<any>(url, {
        headers: this.headerService.getHttpHeaders(),
        params
      }).pipe(
        catchError(err => throwError(() => err))
      );
    }

    postUserDefinedHeatingArea(object: IUserDefArea, heatingSystemId: number | null): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/userDefinedHeatingArea';

      let params = new HttpParams();
      if (heatingSystemId != null) {
        params = params.set('heatingSystemId', String(heatingSystemId));
      }

      return this.http.post<any>(url, object, {
        headers: this.headerService.getHttpHeaders(),
        params
      }).pipe(
        catchError(err => throwError(() => err))
      );
    }

    deleteCustomHeatingArea(areaId: number): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/userDefinedHeatingArea';

      // NOTE: your original code used `heatingSystemId=${areaId}` (variable name mismatch).
      // Keep behavior the same unless it's actually a bug.
      const params = new HttpParams().set('heatingSystemId', String(areaId));

      return this.http.delete<any>(url, {
        headers: this.headerService.getHttpHeaders(),
        params
      });
    }

    cancelCustomAreaCalc(areaId: number): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/userDefinedHeatingArea/cancelCalculation';

      const params = new HttpParams().set('heatingSystemId', String(areaId));

      return this.http.get<any>(url, {
        headers: this.headerService.getHttpHeaders(),
        params
      });
    }

    postRemotePowerAnalisedResults(remotePowerObj: IRemotePower): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/getPotentialAreas';

      return this.http.post<any>(url, remotePowerObj, {
        headers: this.headerService.getHttpHeaders()
      }).pipe(
        catchError(err => throwError(() => err))
      );
    }

    postRemotePowerDetailsResults(remotePowerDetials: IRemotePowerDetails): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/getTechBasicData';

      return this.http.post<any>(url, remotePowerDetials, {
        headers: this.headerService.getHttpHeaders()
      }).pipe(
        catchError(err => throwError(() => err))
      );
    }

    postRemotePowerDetialsTableResults(data: IRemoteFinish): Observable<any> {
      const url = this.globalService.getRestUrl()
        + '/api/planiranjeDaljinskoOgrevanje/writeResults';

      return this.http.post<any>(url, data, {
        headers: this.headerService.getHttpHeaders()
      }).pipe(
        catchError(err => throwError(() => err))
      );
    }

  // getRemotePowerDetialsTechOptions(): Observable<Array<{id: number, name: string}>> {
  //   return this.techOptions.asObservable();
  // }

}
